import type { CopyShape } from "@tami/core/intl";

import type { WEB_SHELL_COPY_PT_BR } from "../web-shell.copy";

export const WEB_SHELL_COPY_ES_ES: CopyShape<typeof WEB_SHELL_COPY_PT_BR> = {
  footer: {
    logoAlt: "Logo de Tãmi",
    tagline: "Tú creas. Tãmi organiza.",
    rights: "Tãmi. Todos los derechos reservados.",
    supportWhatsApp: (phone: string): string => `Soporte por WhatsApp: ${phone}`,
  },
  cookies: {
    before:
      "Usamos cookies y grabación de sesiones para entender cómo se usa la app y mejorar Tãmi. No vendemos tus datos ni los usamos para anuncios. Si los rechazas, dejamos de medir y de grabar.",
    privacyLink: "Política de privacidad",
    accept: "Aceptar",
    decline: "Rechazar",
    close: "Cerrar",
  },
  bioSite: {
    logoAlt: "Tãmi",
    socialNavAria: "Redes sociales de Tãmi",
    featuresNavAria: "Funciones",
    linksNavAria: "Enlaces principales",
    whatsapp: "WhatsApp",
    email: "Correo",
  },
  legalDocument: {
    updatedAt: "Última actualización el",
    taxId: "CNPJ",
  },
  hideValues: {
    show: "Mostrar valores",
    hide: "Ocultar valores",
  },
  sponsoredBilling: {
    before: "Suscripción pagada por",
    after: ". Para cambiar de plan o de forma de pago, habla con la Collab.",
  },
  sessionRevoke: {
    sessionIn: "La sesión en",
    afterSession: "se cerrará y tendrás que volver a iniciar sesión allí.",
  },
  modal: {
    close: "Cerrar ventana",
  },
  floatingRefresh: {
    aria: "Recargar página",
  },
  loading: {
    page: "Cargando página",
    navigation: "Cargando navegación",
  },
  mainNavigationAria: "Navegación principal",
  allPlatforms: "Todas las plataformas",
};
